import { motion } from "framer-motion";
import { toast } from "react-toastify"
import xMark from "../assets/icons/xmark.svg"
import xMarkBlue from "../assets/icons/xmark-blue.svg"
import AppContext from "../context/AppContext"
import { useState, useRef, useContext } from "react"

function Contact() {
    const { showModal, closeForm } = useContext(AppContext)
    const [form, setForm] = useState({
        contactBy: '0',
        email: '',
        message: '',
        org: '',
        phone: ''
    })
    const [errors, setErrors] = useState({
        orgErr: '',
        emailErr: '',
        phoneErr: '',
        contactByErr: '',
        messageErr: ''
    })

    const {
        orgErr,
        emailErr,
        phoneErr,
        contactByErr,
        messageErr
    } = errors

    const closeRef = useRef()

    const hover = () => {
        closeRef.current.src = xMarkBlue
    }

    const unHover = () => {
        closeRef.current.src = xMark
    }

    const updateForm = (e) => {
        setForm((values) => ({...values, [e.target.name]: e.target.value}))
    }

    const updateError = (err, value) => {
        setErrors((values) => ({...values, [err]: value}))
    }

    const removeError = (err) => {
        setErrors((values) => ({...values, [err]: ''}))
    }

    const isEmail = (value) => {
        // Regular expression for a basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      
        // Test the value against the regex
        return emailRegex.test(value);
    }

    const resetErrors = () => {
        removeError('orgErr')
        removeError('emailErr')
        removeError('phoneErr')
        removeError('contactByErr')
        removeError('messageErr')
    }

    const submitForm = (e) => {
        e.preventDefault()
        resetErrors()
        if(!form.org){
            updateError('orgErr', 'Please enter your organization name')
        }

        if(!form.email){
            updateError('emailErr', 'Please enter your email')
        }

        if(!isEmail(form.email) && form.email){
            updateError('emailErr', 'Please enter a valid email')
        }

        if(!form.phone){
            updateError('phoneErr', 'Please enter your phone number')
        }

        if(parseInt(form.contactBy) === 0 || !form.contactBy){
            updateError('contactByErr', 'Please select a contact method')
        }

        if(!form.message){
            updateError('messageErr', 'Please enter a message')
        }

        if(form.org && form.email && isEmail(form.email) && form.phone && form.contactBy && form.message && parseInt(form.contactBy) > 0){
            toast.success('Message sent successfully')
            console.log(form)
            setForm({
                contactBy: '0',
                email: '',
                message: '',
                org: '',
                phone: ''
            })
            closeForm()
        }
        
    }
    
  return (
    <motion.aside
        id="contact"
        initial={{opacity: 0}}
        animate={{opacity: 1}}
        exit={{x: window.innerWidth, transition: { duration: 0.1 }}} 
        className={`${showModal ? 'show' : 'hide'}`}
    >
        <form onSubmit={submitForm} name="contact">
            <div>
                <h3>Contact form</h3>
                <img
                ref={closeRef} 
                src={xMark} 
                alt="close"
                onMouseOver={hover}
                onMouseOut={unHover}
                onClick={closeForm}
                />
            </div>
            <div className="inputs">
                <div className="inputCon">
                    <div className={orgErr ? 'err' : ''}>
                        <label htmlFor="org">Name/Organization name</label>
                        <input type="text" name="org" id="org" value={form.org || ''} onChange={updateForm}/>
                        {orgErr && <div className="error">{orgErr}</div>}
                    </div>
                    <div className={emailErr ? 'err' : ''}>
                        <label htmlFor="email">Email</label>
                        <input type="email" name="email" id="email" value={form.email || ''} onChange={updateForm} autoComplete="false"/>
                        {emailErr && <div className="error">{emailErr}</div>}
                    </div>
                    <div className={phoneErr ? 'err' : ''}>
                        <label htmlFor="phone">Phone number</label>
                        <input type="tel" name="phone" id="phone" value={form.phone || ''} onChange={updateForm} autoComplete="false"/>
                        {phoneErr && <div className="error">{phoneErr}</div>}
                    </div>
                    <div className={contactByErr ? 'err' : ''}>
                        <label htmlFor="contactBy">Preferred contact method</label>
                        <select name="contactBy" id="contactBy" onChange={updateForm}>
                            <option value={0}>Select an Option</option>
                            <option value={1}>Phone</option>
                            <option value={2}>Email</option>
                        </select>
                        {contactByErr && <div className="error">{contactByErr}</div>}
                    </div>
                    <div className={messageErr ? 'err' : ''}>
                        <label htmlFor="message">Message</label>
                        <textarea name="message" id="message" rows={10} value={form.message || ''} onChange={updateForm}/>
                        {messageErr && <div className="error">{messageErr}</div>}
                    </div>
                </div>
                <div className="btnDiv">
                    <button className="blueBtn" type="submit">Submit</button>
                </div>
            </div>
        </form>
    </motion.aside>
  )
}

export default Contact